import type { BufferGeometry } from 'three'
import { mergeGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils.js'

/**
 * 合并特征面的独占片段，并接管中间几何的释放责任。
 * 单片直接转移所有权，零片返回空值；多片无论合并成功还是失败均释放输入几何。
 * @param geometries 已与源模型 BufferAttribute 隔离的独占面片。
 * @returns 交给 FeatureFace 生命周期持有的完整几何。
 */
export function mergeOwnedFaceGeometries(geometries: BufferGeometry[]): BufferGeometry | null {
  if (geometries.length < 2) return geometries[0] ?? null
  try {
    const merged = mergeGeometries(geometries)
    if (!merged) throw new Error('拓扑面片几何属性不兼容，无法构建完整高亮面')
    return merged
  } finally {
    geometries.forEach(geometry => geometry.dispose())
  }
}
